import { render, staticRenderFns } from "./BattlesListPage.vue?vue&type=template&id=0fdb8b03&scoped=true&"
import script from "./BattlesListPage.vue?vue&type=script&lang=ts&"
export * from "./BattlesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./BattlesListPage.vue?vue&type=style&index=0&id=0fdb8b03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb8b03",
  null
  
)

export default component.exports